import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {Business} from "../../model/business";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {CookieService} from "angular2-cookie/core";
import {BusinessService} from "../data/business.service";

@Injectable()
export class CurrentBusinessService {
  // Observable string sources
  private businessChangedSource = new Subject<Business>();
  private businessesChangedSource = new Subject<Business[]>();
  currentBusiness: Business;

  businesses: Business[];

  businessChange$ = this.businessChangedSource.asObservable();

  businessesChange$ = this.businessesChangedSource.asObservable();

  logoCount: number = 0;

  constructor(private urlService: UrlService, private authent: AuthentService,
              private cookieService: CookieService, private businessService: BusinessService) {
  }

  changeBusinesses(businesses: Business[]) {
    this.businesses = businesses.map(business => {
      business.logoPath = this.urlService.getUploadBusinessLogoUrl(business.id) + '?access_token=' + this.authent.getToken();
      business.bannerPath = this.urlService.getUploadBusinessBannerUrl(business.id) + '?access_token=' + this.authent.getToken();

      return business;
    });

    this.businessesChangedSource.next(this.businesses);
  }

  // Service message commands
  changeBusiness(business: Business) {
    this.currentBusiness = business;

    if (this.currentBusiness.premium != null) {
      if (this.currentBusiness.premium.stop < new Date().getTime()) {
        this.currentBusiness.premium.expired = true;
      } else {
        this.currentBusiness.premium.expired = false;
      }
    }

    this.currentBusiness.logoPath = this.urlService.getUploadBusinessLogoUrl(this.currentBusiness.id) + '?access_token=' + this.authent.getToken();
    this.currentBusiness.bannerPath = this.urlService.getUploadBusinessBannerUrl(this.currentBusiness.id) + '?access_token=' + this.authent.getToken();

    this.cookieService.put('us_b', JSON.stringify(this.currentBusiness));

    this.businessChangedSource.next(this.currentBusiness);
  }

  getBusiness() {
    this.currentBusiness.logoPath = this.urlService.getUploadBusinessLogoUrl(this.currentBusiness.id) + '?access_token=' + this.authent.getToken();
    this.currentBusiness.bannerPath = this.urlService.getUploadBusinessBannerUrl(this.currentBusiness.id) + '?access_token=' + this.authent.getToken();

    return this.currentBusiness;
  }

  reloadLogo() {
    this.logoCount++;
    this.currentBusiness.logoPath = this.urlService.getUploadBusinessLogoUrl(this.currentBusiness.id) + '?access_token=' + this.authent.getToken()+'&logoCount='+this.logoCount;
  }

  clear() {
    this.currentBusiness = null;
    this.businesses = null;
  }

  reloadBusiness() {
    this.businessService.getBusiness(this.currentBusiness.id).subscribe(
      business => {
        this.changeBusiness(business);
      }
    )
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/communication/currentBusinessService.ts